// export const BASE_URL = 'https://ugarit-mirror-api.beetronix.com/api'

// Client

/* Cardamom */
// export const BASE_URL = 'https://ugarit-api.beetronix.com/api'
// export const BASE_URL = 'https://ugarit-api.mirta.net/api'

/* Black pepper */
// export const BASE_URL = 'https://ugarit-pepper-api.beetronix.com/api'
// export const BASE_URL = 'http://beeserver:91/api'
export const BASE_URL = 'https://ugarit-pepper-api.mirta.net/api'
export const VERSION = '1.15.0'
